"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TourInfoBlock = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseTranslation = require("nicbase-translation");

var _constants = require("../../constants");

var _latestDataDetails = _interopRequireDefault(require("./latest-data-details"));

var _tourAlarmInfosBlock = _interopRequireDefault(require("./tour-alarm-infos-block"));

var _tourTimesBlock = _interopRequireDefault(require("./tour-times-block"));

require("./tour-info-block.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TourInfoBlock = function TourInfoBlock(_ref) {
  var tour = _ref.tour,
      latestData = _ref.latestData;
  var activatedAlarms = tour.activatedAlarms;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "tour-info-block max-w-144"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "tour-location gradient-divider-bottom"
  }, /*#__PURE__*/_react["default"].createElement(_latestDataDetails["default"], {
    tour: tour,
    latestData: latestData
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "tour-times-and-distance-info gradient-divider-bottom"
  }, tour.status === _constants.TOUR_STATUS.WAITING ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "tour-not-started"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourboard.infoBlock.tourNotStarted",
    tagName: "span"
  })) : /*#__PURE__*/_react["default"].createElement(_tourTimesBlock["default"], {
    tour: tour,
    latestData: latestData
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "tour-alarms"
  }, /*#__PURE__*/_react["default"].createElement(_tourAlarmInfosBlock["default"], {
    activatedAlarms: activatedAlarms
  })));
};

exports.TourInfoBlock = TourInfoBlock;
TourInfoBlock.propTypes = {
  tour: _propTypes["default"].shape({
    assetId: _propTypes["default"].number,
    id: _propTypes["default"].string,
    status: _propTypes["default"].string,
    scheduledStartTime: _propTypes["default"].string,
    scheduledEndTime: _propTypes["default"].string,
    realEndTime: _propTypes["default"].string,
    realStartTime: _propTypes["default"].string,
    activatedAlarms: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
    wayPoints: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
  }).isRequired,
  latestData: _propTypes["default"].shape({}).isRequired
};
var _default = TourInfoBlock;
exports["default"] = _default;